import { render } from "./TrangleButton.vue?vue&type=template&id=3315d28a&scoped=true"
const script = {}

import "./TrangleButton.vue?vue&type=style&index=0&id=3315d28a&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3315d28a"]])

export default __exports__